var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "checkbox"
    ? _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue"
              }
            ],
            staticClass:
              "border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150",
            class: { "border-red-500": _vm.error, "bg-gray-300": _vm.disabled },
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              maxlength: _vm.maxLength,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.localValue)
                ? _vm._i(_vm.localValue, null) > -1
                : _vm.localValue
            },
            on: {
              change: function($event) {
                var $$a = _vm.localValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localValue = $$c
                }
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
    : _vm.type === "radio"
    ? _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue"
              }
            ],
            staticClass:
              "border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150",
            class: { "border-red-500": _vm.error, "bg-gray-300": _vm.disabled },
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              maxlength: _vm.maxLength,
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.localValue, null) },
            on: {
              change: function($event) {
                _vm.localValue = null
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
    : _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue"
              }
            ],
            staticClass:
              "border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150",
            class: { "border-red-500": _vm.error, "bg-gray-300": _vm.disabled },
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              maxlength: _vm.maxLength,
              type: _vm.type
            },
            domProps: { value: _vm.localValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localValue = $event.target.value
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-453698c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-453698c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Form/Input.vue
// module id = null
// module chunks = 